// Priority Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { priorityConfig } from './priorityConfig';
import { createPriorityValidation } from './priorityValidation';
// PriorityService no longer needed - using SWR hooks directly

/**
 * Initialize the priority module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  priorityConfig,
  createPriorityValidation
);

/**
 * Create the PriorityPage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const PriorityPage = createModulePage(
  initializedConfig,
  {
    displayName: 'PriorityPage',
    description: 'Priority Management System - Manage priority levels for QMS records'
  }
);

export default PriorityPage;
